import React, { useEffect, useRef, useState } from 'react'
import { CToast, CToastBody, CToastClose, CToaster, CToastHeader } from '@coreui/react'
import moment from 'moment'

export const Toast = () => {
    const [toast, addToast] = useState()
    const toaster = useRef(null)
    useEffect(() => {
        window.toast = (message, level = 'danger') => {
            if(level == 'error') level = 'danger'
            addToast(
                <CToast key={moment.now()} color={level} className="text-white align-items-center">
                    <div className="d-flex justify-content-end">
                        <CToastBody style={{whiteSpace:'pre-wrap', width:'calc(100% - 30px)'}}>{message}</CToastBody>
                        <CToastClose className="me-2" style={{marginTop:5}} white/>
                    </div>
                </CToast>,
            )
        }
    }, [])

    return (
        <>
            <CToaster style={{padding:5, top:50, right:10}} push={toast} ref={toaster} />
        </>
    )
}
